import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {makeStyles} from '@mui/styles'
import {Spacing, Colors, Typography} from '../../assets/styles'
import {borderRadiusMedium} from '../../assets/styles/border'
import DataComingSoon from '../DataComingSoon'
import ExitSurveyVideoCard from './ExitSurveyVideoCard'
import ExitSurveyVideoPlayerModal from './ExitSurveyVideoPlayerModal'

const TITLE = 'Latest video responses'

/**
 * @param {Object} props
 * @param {Array<import('./exitSurveyVideoData').VideoResponse>} props.responses
 */
function RecentVideoResponses({responses}) {
  const classes = useStyles()

  const [playingResponse, setPlayingResponse] = useState(null)

  return (
    <div className={classes.section}>
      <div className={classes.title}>{TITLE}</div>

      {responses.length === 0 ? (
        <DataComingSoon />
      ) : (
        <div className={classes.grid}>
          {responses.map(response => (
            <ExitSurveyVideoCard key={response.id} response={response} onPlay={setPlayingResponse} />
          ))}
        </div>
      )}

      <ExitSurveyVideoPlayerModal response={playingResponse} onClose={() => setPlayingResponse(null)} />
    </div>
  )
}

RecentVideoResponses.propTypes = {
  responses: PropTypes.array.isRequired,
}

const useStyles = makeStyles({
  section: {
    marginTop: Spacing.spaceMedium,
    marginBottom: Spacing.spaceMedium,
    padding: Spacing.spaceMedium,
    backgroundColor: Colors.rxrWhiteColor,
    border: `1px solid ${Colors.rxrGreyColor}`,
    borderRadius: borderRadiusMedium,
    boxShadow: Colors.shadowSoft,
  },
  title: {
    marginBottom: Spacing.spaceMedium,
    fontSize: Typography.fontSizeLarge,
    fontWeight: Typography.heavyFontWeight,
    color: Colors.rxrBlackColor,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    gap: Spacing.spaceMedium,
  },
})

export default RecentVideoResponses
